<template>
  <div class="container bg_f9">
    <div class="head_part flex-box w1440">
      <!-- <router-link to="/"><img class="login_logo point mr30" src="../../assets/static/icon/jxr_login_logo.png"
          alt="" /></router-link> -->
          <router-link to="/"><img class="login_logo point ml10 mr30" src="../../assets/static/images/jj_logo_new.png"
            alt="" /></router-link>
      <div class="line mr30"></div>
      <div class="fs24 col-36 fw-600">欢迎登录</div>
    </div>
    <div class="main flex-box">
      <div class="part1">
        <div class="title tc mb40">欢迎登录</div>
        <form name="form" id="login-form" method="POST">
          <div class="part2 flex-box">
            <img class="img1" src="../../assets/static/icon/jxr_login_phone.png" alt="" />
            <input class="input fs16" type="text" name="mobile" placeholder="手机号" v-model="mobile" />
          </div>
          <div class="part2 part3 flex-box">
            <img class="img1" src="../../assets/static/icon/jxr_login_password.png" alt="" />
            <input class="input fs16" id="password" :type="showPwd ? 'text' : 'password'" name="password"
              placeholder="请输入密码" v-model="password" />
            <img @click="showPwd = !showPwd" v-if="showPwd" class="img2 point"
              src="../../assets/static/icon/jxr_login_show.png" alt="" id="eye" />
            <img @click="showPwd = !showPwd" v-else class="img2 point" src="../../assets/static/icon/jxr_login_hide.png"
              alt="" id="eye" />
          </div>
          <div class="part4 flex-box lh26">
            <div class="flex-box flex-grow-1">
              <div class="checkbox point">
                <input class="check_img fs16" type="checkbox" name="keeplogin" :checked="rememberAccount" />
              </div>
              <div class="fs14 col3 cursor" @click="rememberAccount = !rememberAccount">记住账号</div>
            </div>
            <router-link to="/RetrievePassword" class="fs14 col3 point">忘记密码？</router-link>
          </div>
          <div class="btn_login point" @click="login">登录</div>
          <router-link to="NewInstitutions" class="fs14 col3 lh26 flex-box flex-center"> 没有账号？请<span
              class="blue point">立即注册</span>
          </router-link>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { useHead } from "@unhead/vue";
export default {
  name: "index",
  setup() {
    useHead({
      title: "登录-小狮优选",
      meta: [
        {
          name: "description",
          content: "This is my page description",
        },
        {
          property: "og:title",
          content: "My Page Title",
        },
        {
          property: "og:description",
          content: "This is my page description",
        },
        {
          property: "og:url",
          content: "https://example.com/my-page",
        },
        {
          property: "og:image",
          content: "https://example.com/my-image.jpg",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://example.com/my-page",
        },
      ],
    });
  },
  data() {
    return {
      rememberAccount: true,
      showPwd: false,
      mobile: "",
      password: "",
      isloading: false
    };
  },
  mounted() {
    this.$store.commit("setHeader", false);
    this.$store.commit("setFooter", false);
    this.$store.commit("setRouter", false);
    if (this.$cookies.get("account")) {
      this.mobile = this.$cookies.get("account");
    }
  },
  beforeUnmount() {
    this.$store.commit("setHeader", true);
    this.$store.commit("setFooter", true);
    this.$store.commit("setRouter", true);
  },
  methods: {
    login() {
      let that = this;
      if (that.isloading) {
        return;
      }
      that.isloading = true;
      that.$api.Login({
        mobile: that.mobile,
        password: that.password,
        showToast: true
      }).then((res) => {
        that.isloading = false;
        if (res.code == 1) {
          if (this.rememberAccount) {
            that.$cookies.set("account", that.mobile);
          }
          that.$cookies.set("token", res.data.userinfo.token);
          that.$message({
            customClass: 'custom-message',
            message: "登录成功",
            type: "success",
            duration: 3000,
          });
          that.$bus.emit("refreshMessage",{});
          that.getUserInfo();
        } else {
          that.$message({
            customClass: 'custom-message',
            message: res.msg,
            type: "error",
            duration: 3000,
          });
        }
      }).catch(err => {
        that.isloading = false;
        that.$message({
          customClass: 'custom-message',
          message: err.msg,
          type: "error",
          duration: 3000,
        });
      })
    },
    // 获取用户信息
    getUserInfo() {
      let that = this;
      that.$api.GetUserInfo().then(res => {
        if (res.code == 1) {
          let userinfo = {
            avatar: res.data.group_model.avatar,
            mobile: res.data.group_model.mobile,
            vip: res.data.group_model.vip,
            score: res.data.group_model.score,
            institution_sun_count: res.data.institution_sun_count,
            company_name: res.data.group_model.company_name,
            institution_type: res.data.group_model.institution_type,
          }
          this.$cookies.set('userinfo', userinfo);
          this.$router.push('/');
          this.$bus.emit("refreshLogin");
        }
      }).catch(err => {
        console.log(err)
      })
    },
  },
};
</script>

<style lang="less" scoped>
.point {
  cursor: pointer;
}

.bg_f9 {
  background: #f9f9f9;
}

.head_part {
  // width: 1400px;
  margin: 0 auto;
  padding: 30px 0;
}

.login_logo {
  width: 165px;
  display: block;
  object-fit: contain;
}

.line {
  width: 1px;
  height: 45px;
  background: #979797;
}

.col-36 {
  color: #363636;
}

.fw-600 {
  font-weight: 700;
}

.main {
  background: url(../../assets/static/icon/jxr_login_bj.png) no-repeat;
  background-size: cover;
  width: 100vw;
  height: 527px;
}

.part1 {
  margin-left: auto;
  margin-right: calc((100vw - 1440px) / 2);
  width: 368px;
  padding: 56px 40px 30px;
  background: #fff;
  border-radius: 18px;
}
@media screen and (max-width: 1440px) {
  .part1{margin-right: 30px;}
}
.part1 .title {
  font-weight: 700;
  font-size: 18px;
  color: #3d7efe;
  line-height: 32px;
}

.part2 {
  width: 290px;
  height: 45px;
  margin: 0 auto 20px;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #3d7efe;
  padding-left: 16px;
}

.part2 .img1 {
  width: 18px;
  display: block;
  object-fit: contain;
  margin-right: 12px;
}

.part2 .img2 {
  width: 18px;
  display: block;
  object-fit: contain;
  margin-right: 16px;
}

.part3 {
  margin: 0 auto 16px;
}

.check_img {
  width: 14px;
  height: 14px;
  margin-right: 6px;
  background: rgba(240, 84, 77, 1);
  margin-top: 0;
}

input[type="checkbox"] {
  width: 14px;
  height: 14px;
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  line-height: 15px;
  position: relative;
}

input[type="checkbox"]::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  background: #fff;
  width: 100%;
  height: 100%;
  border: 1px solid #c5cdd6;
}

input[type="checkbox"]:checked::before {
  content: "\2713";
  background-color: #3d7efe;
  position: absolute;
  bottom: 4px;
  left: 0px;
  width: 100%;
  border: 1px solid #3d7efe;
  color: #fff;
  font-size: 10px;
  font-weight: bold;
}

.input {
  padding: 0;
  height: 100%;
  line-height: 100%;
  flex: 1;
  border: none;
  outline: none;
}

.input::placeholder {
  font-size: 20px;
  color: #d3d3d3;
}

.part4 {
  width: 290px;
  margin: 0 auto 30px;
}

.btn_login {
  border: none;
  margin: 0 auto 30px;
  font-size: 14px;
  color: #fff;
  font-weight: 700;
  text-align: center;
  width: 290px;
  line-height: 45px;
  border-radius: 6px;
  background: #3d7efe;
}

.part6 {
  background: #f3f3f3;
  padding: 79px 260px 44px;
  width: 100vw;
}

.part7 {
  // width: 1400px;
  margin: 0 auto 46px;
  display: flex;
}

.part8 {
  background: #fff;
  border-radius: 12px;
  padding: 10px;
  margin-bottom: 14px;
}

.part9 {
  background: #fff;
  border-radius: 12px;
  padding: 11px;
  margin-bottom: 14px;
}

.part10 {
  // width: 1400px;
  height: 1px;
  background: #dedede;
  margin: 0 auto 22px;
}

.title4 {
  font-size: 18px;
  line-height: 20px;
  color: #2b2b2b;
  margin-bottom: 25px;
}

.title5 {
  font-size: 16px;
  line-height: 18px;
  color: #686868;
  margin-bottom: 16px;
}

.title6 {
  font-size: 16px;
  line-height: 17px;
  color: #686868;
  text-align: center;
}

.title7 {
  font-size: 16px;
  line-height: 17px;
  color: #686868;
  text-align: center;
}

.title8 {
  font-size: 16px;
  line-height: 16px;
  color: #b8b8b8;
  text-align: center;
}

.img3 {
  width: 112px;
  height: 112px;
  display: block;
  margin: auto;
  object-fit: contain;
}

.img4 {
  width: 112px;
  height: 112px;
  display: block;
  margin: auto;
  object-fit: contain;
}

.blue {
  color: #3d7efe;
}
</style>
